<template>
  <div class="popup-fence-card">
    <div class="popup-fence-header d-flex align-items-center justify-content-between mb-1">
      <div class="d-flex align-items-center">
        <div class="popup-icon-wrapper mr-50">
          <feather-icon icon="ShieldIcon" size="16" class="text-primary" />
        </div>
        <div>
          <h6 class="mb-0 font-weight-bolder text-truncate popup-title" :title="name">
            {{ name }}
          </h6>
          <span v-if="virtualFenceTypeName" class="font-small-2 text-muted">
            {{ virtualFenceTypeName }}
          </span>
        </div>
      </div>
      <b-badge v-if="maxSpeed" variant="light-warning" class="font-small-1 font-weight-bold" v-b-tooltip.hover :title="$t('Max Speed')">
        <feather-icon icon="GaugeIcon" size="10" class="mr-25" />
        {{ maxSpeed }} km/h
      </b-badge>
    </div>

    <!-- Alertas Badges Grid -->
    <div class="popup-alerts-grid mb-1">
      <div class="alert-item" :class="{ 'is-active': alertIn }">
        <feather-icon :icon="alertIn ? 'CheckCircleIcon' : 'MinusCircleIcon'" size="12" class="mr-25" />
        <span>{{ $t('Alert In') }}</span>
      </div>
      <div class="alert-item" :class="{ 'is-active': alertOut }">
        <feather-icon :icon="alertOut ? 'CheckCircleIcon' : 'MinusCircleIcon'" size="12" class="mr-25" />
        <span>{{ $t('Alert Out') }}</span>
      </div>
      <div class="alert-item" :class="{ 'is-active': alertStayIn }">
        <feather-icon :icon="alertStayIn ? 'CheckCircleIcon' : 'MinusCircleIcon'" size="12" class="mr-25" />
        <span>{{ $t('Alert Stay In') }}</span>
      </div>
      <div class="alert-item" :class="{ 'is-active': alertStayOut }">
        <feather-icon :icon="alertStayOut ? 'CheckCircleIcon' : 'MinusCircleIcon'" size="12" class="mr-25" />
        <span>{{ $t('Alert Stay Out') }}</span>
      </div>
    </div>

    <!-- Ações -->
    <div class="popup-actions d-flex justify-content-end" style="gap: 6px;">
      <b-button
        variant="primary"
        size="sm"
        class="d-inline-flex align-items-center"
        @click="edit()"
      >
        <feather-icon icon="Edit2Icon" size="13" class="mr-50" />
        {{ $t('Edit') }}
      </b-button>
      <b-button
        v-if="!hideDelete"
        variant="outline-danger"
        size="sm"
        class="d-inline-flex align-items-center"
        @click="del()"
      >
        <feather-icon icon="Trash2Icon" size="13" class="mr-50" />
        {{ $t('Delete') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BBadge, BButton, VBTooltip } from 'bootstrap-vue'

export default {
  name: 'PopupFence',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BBadge,
    BButton,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    myId: {
      type: String,
      required: true,
    },
    maxSpeed: {
      type: [String, Number],
      required: false,
      default: null,
    },
    alertIn: {
      type: Boolean,
      required: true,
    },
    alertOut: {
      type: Boolean,
      required: true,
    },
    alertStayIn: {
      type: Boolean,
      required: false,
      default: false,
    },
    alertStayOut: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFence: {
      type: Boolean,
      required: false,
      default: true,
    },
    virtualFenceTypeName: {
      type: String,
      required: false,
      default: null,
    },
    hideDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    del() {
      this.isFence ? this.$emit('event-delete-fence') : this.$emit('event-delete-point')
    },
    edit() {
      this.isFence ? this.$emit('event-to-fence') : this.$emit('event-to-point')
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-fence-card {
  min-width: 240px;
  max-width: 280px;
  padding: 4px;
}

.popup-title {
  max-width: 170px;
  color: #2c2e3e;
}

.popup-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background-color: rgba(115, 103, 240, 0.12);
}

.popup-alerts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
  background: #f8f8fa;
  border-radius: 6px;
  padding: 6px 8px;
}

.alert-item {
  display: flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 500;
  color: #a0a2b1;

  &.is-active {
    color: #28c76f;
    font-weight: 600;
  }
}
</style>
